import { createFileRoute } from '@tanstack/react-router';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/_layout')({
  component: ManagerPortal,
});
